import React, {Component} from "react";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import {Card, Modal, ModalHeader} from "reactstrap"
import TextField from '@material-ui/core/TextField';
import Dropzone from 'react-dropzone';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/styles';
import {isEmpty} from 'lodash'
import EmojiMenu from '../PostList/EmojiMenu'
import { injectIntl } from 'react-intl';
import IntlMessages from 'util/IntlMessages';
const styles = theme => ({
  noBorder: {
    border: 'none !important',
  },
  messageInput: {
    fontSize: 18,
    '&::placeholder': {
      fontSize: 18,
    }
  },
  messageRoot: {
    padding: '10px 15px !important',
  }
});

class WriteBox extends Component {

  state = {
    commentText: '',
    previewVisible: false,
    previewImage: '',
    fileList: [],
    rejected: [],
    isOpen: false,
    
  };

  handleCancel = () => this.setState({previewVisible: false})

  handlePreview = (file) => {
    console.log("previewImage", file)
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    });
  }

  onDrop = files => {
    console.log("file-->", files)
    this.setState({
      fileList: files,
    });
  };

  handleChange = ({fileList}) => {
    console.log("fileList", fileList)
    this.setState({fileList})
  }

  handleClickImage() {
    this.setState((previousState) => ({
      isOpen: !previousState.isOpen
    }));
  }

  handleAddPost() {
    this.props.AddNewFlode(this.state.commentText);
    this.setState({
      commentText: '',
      previewVisible: false,
      previewImage: '',
      fileList: [],
      isOpen: false,
    });
  }
 
  onChange(e) {
    this.setState({commentText: e.target.value})
  }

  render() {
    const {classes} = this.props
    const {previewVisible, previewImage, fileList} = this.state;
    console.log("this.state.fileList.length", fileList.length)
    const isEnabled = fileList.length === 0 && this.state.commentText === "";

    return (
      <div className="p-3">
        <div className="d-flex align-items-center">
          <Avatar src={this.props.authUser.user_profile_pic} size="large" className={'size-50'}>
            {this.props.authUser.user_fnamn[0]}{isEmpty(this.props.authUser.user_lnamn)?"":this.props.authUser.user_lnamn[0]}
          </Avatar>
            <TextField
              id="exampleTextarea"
              // label="Vad vill du dela idag?"
              placeholder={this.props.intl.formatMessage({ id: 'Placeholder.Post' })}
              value={this.state.commentText}
              onChange={(event) => this.onChange(event)}
              multiline
              fullWidth
              size="small"
              // className="jr-wall-textarea"
              margin="none"
              variant="outlined"
              InputProps={{
                classes: {notchedOutline:classes.noBorder, input: classes.messageInput, root: classes.messageRoot }
              }}
              rows="2"
            />
        </div>
        

        <div className="d-flex justify-content-end">
          <EmojiMenu addEmoji={(emoji) => this.setState({...this.state, commentText: this.state.commentText + ' ' + emoji })} />
          <Button color="primary" size='small'
          className="ml-2"
                  disabled={this.state.commentText.length < 3}
                  // disabled={(isEnabled) ? "disabled" : ""}
                  onClick={this.handleAddPost.bind(this)}><IntlMessages id="Label.Publish"/>
          </Button>
        </div>
        </div>
    )
    // return (
    //   <>
    
    //       <div className="media-body">
    //         <TextField
    //           id="exampleTextarea"
    //           label="Vad vill du dela idag?"
    //           placeholder="Skriv ditt meddelande här."
    //           value={this.state.commentText}
    //           onChange={(event) => this.onChange(event)}
    //           multiline
    //           fullWidth
    //           className="jr-wall-textarea"
    //           margin="none"
    //           variant="outlined"
    //           rows="3"
    //         />
    //       </div>
        


    //       <Button color="primary" size='small' className="ml-auto mb-2"
    //               // disabled={(isEnabled) ? "disabled" : ""}
    //               onClick={this.handleAddPost.bind(this)}><IntlMessages id="Label.Publish"/>
    //       </Button>
    //       </>
    // )
  }
}


export default injectIntl(withStyles(styles)(WriteBox));